import React from 'react';
import MUICssBaseline, {
  CssBaselineProps,
} from '@material-ui/core/CssBaseline';

const CssBaseline = (props: CssBaselineProps) => {
  return <MUICssBaseline {...props}>{props.children}</MUICssBaseline>;
};

export default CssBaseline;
